export default __webpack_public_path__ + "static/media/market-place.78e342aa.webp";